import { render, staticRenderFns } from "./MonthlyTrafficPreview.vue?vue&type=template&id=4947ffa9&scoped=true"
import script from "./MonthlyTrafficPreview.vue?vue&type=script&lang=js"
export * from "./MonthlyTrafficPreview.vue?vue&type=script&lang=js"
import style0 from "./MonthlyTrafficPreview.vue?vue&type=style&index=0&id=4947ffa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947ffa9",
  null
  
)

export default component.exports